(function() {
  var $48c3778e117950a9$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("vanilla-slider")) customElements.define("vanilla-slider", class VanillaSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = this.querySelector("[data-slider]");
        this.slides = this.querySelectorAll("[data-slide]");
        this.prev = this.querySelectorAll("[data-prev]");
        this.next = this.querySelectorAll("[data-next]");
        this.nav = this.querySelectorAll("[data-nav]");
        this.progress = this.querySelector("[data-progress]");
        this.loop = this.hasAttribute("data-loop") || this.dataset.loop === "true";
        this.firstRealSlide = null;
        this.firstPostClone = null;
        this.autoplay = Number(this.dataset.autoplay * 1e3 || 0);
        if (this.autoplay) this.autoplay, parseInt(getComputedStyle(document.documentElement).getPropertyValue("--duration"));
        this.autoplayIndex = 0;
        this.interval;
        this.lastActiveIndex = 0;
      }
      connectedCallback() {
        if (!this.slider) return false;
        if (this.loop) this.setupInfinite();
        this.addEventListeners();
        window.addEventListener("load", () => {
          if (this.loop) this.resetScrollPosition(true);
          this.update();
        });
        document.addEventListener("DOMContentReady", () => this.update());
        if (this.autoplay) {
          this.initCircleProgress();
          this.startAutoplay();
        }
      }
      setupInfinite() {
        const slidesArr = [ ...this.slides ];
        const preClones = slidesArr.map(s => {
          const c = s.cloneNode(true);
          c.removeAttribute("data-slide");
          c.removeAttribute("id");
          c.setAttribute("data-clone", "prepend");
          c.setAttribute("aria-hidden", "true");
          return c;
        });
        const postClones = slidesArr.map(s => {
          const c = s.cloneNode(true);
          c.removeAttribute("data-slide");
          c.removeAttribute("id");
          c.setAttribute("data-clone", "append");
          c.setAttribute("aria-hidden", "true");
          return c;
        });
        this.slider.prepend(...preClones);
        this.slider.append(...postClones);
        this.firstRealSlide = this.slider.children[preClones.length];
        this.firstPostClone = this.slider.children[preClones.length + slidesArr.length];
      }
      getInfiniteSetWidth() {
        if (!this.firstRealSlide || !this.firstPostClone) return 0;
        return this.firstPostClone.offsetLeft - this.firstRealSlide.offsetLeft;
      }
      checkInfiniteScroll() {
        if (!this.loop) return;
        const scrollLeft = this.slider.scrollLeft;
        const setWidth = this.getInfiniteSetWidth();
        const tolerance = 10;
        if (scrollLeft <= tolerance) this.silentScrollTo(scrollLeft + setWidth); else if (scrollLeft >= setWidth * 2 - tolerance) this.silentScrollTo(scrollLeft - setWidth);
      }
      silentScrollTo(x) {
        this.slider.style.scrollBehavior = "auto";
        this.slider.style.scrollSnapType = "none";
        this.slider.scrollLeft = x;
        this.slider.offsetHeight;
        this.slider.style.scrollBehavior = "";
        this.slider.style.scrollSnapType = "";
      }
      resetScrollPosition(force = false) {
        if (this.loop) {
          const setWidth = this.getInfiniteSetWidth();
          if (this.slider.scrollLeft < setWidth || force) this.silentScrollTo(setWidth);
        }
      }
      getSlideWidth() {
        return ([ ...this.slides ].find(el => el.offsetWidth > 0)?.offsetWidth || this.slider.width) + (parseInt(getComputedStyle(this.slider).getPropertyValue("gap").split(" ")[0]) || 0);
      }
      scroll(direction, event = false) {
        event && event.preventDefault() && event.stopPropagation();
        const amount = this.getSlideWidth();
        this.slider.scrollBy({
          left: direction === "left" ? -amount : amount,
          behavior: "smooth"
        });
      }
      goTo(index, behavior = "smooth") {
        let position = this.getSlideWidth() * parseInt(index);
        if (this.loop && this.firstRealSlide) position += this.firstRealSlide.offsetLeft;
        this.slider.scrollTo({
          left: position,
          behavior: behavior
        });
      }
      updateCenterSlide() {
        if (!this.loop) return;
        const sliderCenter = this.slider.scrollLeft + this.slider.clientWidth / 2;
        let closestSlide = null;
        let minDiff = Infinity;
        [ ...this.slider.children ].forEach(child => {
          if (!child.hasAttribute("data-slide") && !child.hasAttribute("data-clone")) return;
          const slideCenter = child.offsetLeft + child.offsetWidth / 2;
          const diff = Math.abs(sliderCenter - slideCenter);
          if (diff < minDiff) {
            minDiff = diff;
            closestSlide = child;
          }
        });
        const currentActive = this.slider.querySelector("[data-center-slide]");
        if (currentActive !== closestSlide) {
          if (currentActive) currentActive.removeAttribute("data-center-slide");
          if (closestSlide) closestSlide.setAttribute("data-center-slide", "true");
        }
      }
      hideArrow(el) {
        el.disabled = true, el.ariaDisabled = true;
      }
      showArrow(el) {
        el.disabled = false, el.ariaDisabled = false;
      }
      updateArrows() {
        if (this.loop) return;
        this.prev.forEach(this.slider.scrollLeft > 0 ? this.showArrow : this.hideArrow);
        this.next.forEach(this.slider.scrollLeft + this.slider.offsetWidth < this.slider.scrollWidth - parseInt(getComputedStyle(document.documentElement).getPropertyValue("--spacing-offset")) ? this.showArrow : this.hideArrow);
      }
      updateProgress(x = this.slider.scrollLeft) {
        if (!this.progress) return;
        const noOverflow = this.slider.scrollWidth <= this.slider.clientWidth;
        if (noOverflow) {
          this.progress.style.display = "none";
          return;
        } else this.progress.style.display = "";
        let progress;
        if (this.loop) {
          const setWidth = this.getInfiniteSetWidth();
          const relativeX = x - this.firstRealSlide.offsetLeft;
          progress = relativeX / (setWidth - this.slider.clientWidth);
        } else if (!isNaN(this.initialProgress) && this.initialProgress >= 0 && this.initialProgress <= 100) {
          const initialProgressDecimal = this.initialProgress / 100;
          const scrollableWidth = this.slider.scrollWidth - this.slider.clientWidth;
          const scrollProgress = scrollableWidth > 0 ? x / scrollableWidth : 0;
          progress = initialProgressDecimal + scrollProgress * (1 - initialProgressDecimal);
        } else progress = (x + this.slider.clientWidth) / this.slider.scrollWidth;
        progress = Math.max(0, Math.min(1, progress));
        this.style.setProperty("--progress-decimal", progress.toFixed(2));
        this.style.setProperty("--progress", (progress * 100).toFixed(2) + "%");
      }
      initCircleProgress() {
        if (!this.progress || this.progress.dataset.progressType !== "circles") return;
        this.progressCircles = this.progress.querySelectorAll("[data-progress-circle]");
        if (this.autoplay && this.progressCircles.length > 0) {
          const duration = this.dataset.autoplay;
          this.progressCircles.forEach(circle => {
            const fillCircle = circle.querySelector("[data-progress-fill]");
            if (fillCircle) fillCircle.style.transition = `stroke-dashoffset ${duration}s linear`;
          });
        }
      }
      updateCircleProgress() {
        if (!this.progressCircles || this.progress?.dataset.progressType !== "circles") return;
        const currentIndex = this.getIndex();
        if (this.previousCircleIndex === currentIndex) return;
        this.progressCircles.forEach((circle, index) => {
          const fillCircle = circle.querySelector("[data-progress-fill]");
          if (!fillCircle) return;
          if (index === currentIndex) {
            fillCircle.style.transition = "none";
            fillCircle.style.strokeDashoffset = "18.85";
            fillCircle.offsetHeight;
            requestAnimationFrame(() => {
              fillCircle.style.transition = `stroke-dashoffset ${this.dataset.autoplay}s linear`;
              fillCircle.style.strokeDashoffset = "0";
            });
          } else if (index < currentIndex) {
            fillCircle.style.transition = "none";
            fillCircle.style.strokeDashoffset = "0";
          } else {
            fillCircle.style.transition = "none";
            fillCircle.style.strokeDashoffset = "18.85";
          }
        });
        this.previousCircleIndex = currentIndex;
      }
      updateNav() {
        this.nav.forEach(nav => nav.querySelectorAll("button").forEach((dot, index) => {
          const isActive = index === this.getIndex();
          dot.ariaCurrent = isActive ? true : false;
          dot.classList.toggle("is-active", isActive);
        }));
      }
      getIndex() {
        const activeSlide = [ ...this.slides ].find(el => String(el.ariaCurrent) === "true");
        if (activeSlide) this.lastActiveIndex = [ ...this.slides ].indexOf(activeSlide);
        return Math.max(0, this.lastActiveIndex || 0);
      }
      update() {
        this.updateArrows();
        if (this.loop) this.updateCenterSlide();
        setTimeout(() => this.updateNav());
        if (this.progress) {
          setTimeout(() => this.updateProgress());
          if (this.progress.dataset.progressType === "circles") setTimeout(() => this.updateCircleProgress());
        }
      }
      startAutoplay() {
        this.interval = setInterval(() => {
          this.scroll("right");
        }, this.autoplay);
      }
      addEventListeners() {
        this.prev.forEach(el => el.addEventListener("click", event => this.scroll("left", event)));
        this.next.forEach(el => el.addEventListener("click", event => this.scroll("right", event)));
        this.addEventListener("click", event => {
          const btn = event.target.closest("[data-nav] button");
          if (btn) {
            event.preventDefault();
            event.stopPropagation();
            const nav = btn.closest("[data-nav]");
            const index = Array.from(nav.querySelectorAll("button")).indexOf(btn);
            if (index !== -1) this.goTo(index);
          }
        });
        this.closest(".shopify-section")?.addEventListener("input", () => this.goTo(0, "instant"));
        if (this.autoplay) [ "wheel", "touchmove", "click", "keydown" ].forEach(event => {
          this.addEventListener(event, () => {
            clearInterval(this.interval);
            this.style.setProperty("--delay", "var(--duration)");
          }, {
            passive: true
          });
        });
        const intersectionObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => entry.target.ariaCurrent = entry.isIntersecting ? true : false);
        }, {
          root: this.slider,
          threshold: .6
        });
        this.slides.forEach(slide => intersectionObserver.observe(slide));
        const mutationObserver = new MutationObserver(mutations => {
          if (mutations.some(m => [ ...m.addedNodes ].some(n => n.dataset?.clone))) return;
          this.slides = this.querySelectorAll("[data-slide]");
          this.nav = this.querySelectorAll("[data-nav]");
          if (this.loop) this.setupInfinite();
          this.update();
        });
        mutationObserver.observe(this.slider, {
          childList: true
        });
        this.slider.addEventListener("scroll", () => {
          this.update();
        }, {
          passive: true
        });
        this.slider.addEventListener("scrollend", () => {
          if (this.loop) this.checkInfiniteScroll();
          this.update();
        }, {
          passive: true
        });
      }
    });
  })();
})();